import { SnackbarGateway } from '@/domain/snackbar/gateways/snackbar.gateway';
import { createAppAsyncThunk } from '@/domain/store.thunk';
import { Tag } from '@/domain/tags/entities/tag.entity.ts';
import { translate } from '@/ui/i18n';

export const createTag = createAppAsyncThunk(
  'organisation/createTag',
  async (
    tagName: string,
    { extra: { tagsGateway, snackbarGateway } },
  ): Promise<Tag> => {
    try {
      const createdTag = await tagsGateway.createTag(tagName);
      showSnackbarSuccess(snackbarGateway);
      return createdTag;
    } catch (error) {
      showSnackbarError(snackbarGateway);
      throw error;
    }
  },
);

function showSnackbarSuccess(snackbarGateway: SnackbarGateway) {
  snackbarGateway.success(translate('CreateTag.Message.success'));
}

function showSnackbarError(snackbarGateway: SnackbarGateway) {
  snackbarGateway.error(translate('CreateTag.Message.error'));
}
